// bulkSelect — pure decision for a "select all" header checkbox that must act
// across the WHOLE filtered result set, not just the current paginated page
// (#8). Given how many ids are currently selected and the full list of ids,
// return the next selection: an empty set when everything is already selected
// (toggle off), otherwise a set containing every id (select all).

export function nextSelectAll(currentSelectedSize: number, allIds: string[]): Set<string> {
  if (currentSelectedSize === allIds.length) return new Set();
  return new Set(allIds);
}
